export default "https://cdn-static.gokick.com/assets/9c92702f75f0b67707db9d869eecabb5f21facb9/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";